// import { CognitoUser } from 'amazon-cognito-identity-js'

import { getCurrentUserSession } from './config';

export default function(username, newpassword, data = null) {
  // const userData = {
  //   Username: username,
  //   Pool: getUserPool()
  // }

  // const cognitoUser = new CognitoUser(userData)
  const cognitoUser = getCurrentUserSession();

  return new Promise((resolve, reject) => {
    cognitoUser.completeNewPasswordChallenge(newpassword, data, {
      onSuccess(result) {
        resolve(result);
      },
      onFailure(err) {
        reject(err);
      },
    });
  });
}



// WEBPACK FOOTER //
// ./src/redux/sagas/aws-cognito-redux-saga/aws-cognito-promises/completeNewPassword.js